import React from 'react';

export default function Example() {
  return (	<div className="flex justify-center mb-8">
			<a className="items-center" href="https://www.producthunt.com/posts/loveadvisor-ai?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-loveadvisor&#0045;ai" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=461426&theme=light" alt="LoveAdvisor&#0032;AI - Master&#0032;Modern&#0032;Romance&#0032;with&#0032;Personal&#0032;AI&#0032;Relationship&#0032;Guide&#0033; | Product Hunt" style={{width: "250px;", height: "54px;", width:"250", height:"54"}} /></a>
		</div>

	);
}
